export default {
  en: {
    messages: {
      required: 'This value is required',
      min: 'This value must have no less than {length} characters',
      max: (_, { length }) =>
        `This value must have no more than ${length} characters`,
    },
  },
}